import React from 'react'

import { Container } from '@mui/joy'

import i18n from '@/i18n'
import { GenericList } from '@/components/GenericList'
import { RecordingCard } from '@/components/RecordingCard'
import { MusicNote, Waveform } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'

export function DiscoveryModeCampaignsPage() {
  return (
    <DiscoveryModeCampaignsContainer />
  )
}

export function DiscoveryModeCampaignsContainer() {
  return (
    <Container>
      <h3>{i18n.t('discovery-mode-campaigns')}</h3>
        <GenericList
          path={`/discovery-mode-campaigns`}
          query={{
            discoveryMode: true
          }}
          showDefaultColumns={false} 
          canDelete={false}
          canEdit={false}
          canView={false}
          NodeCardComponent={RecordingCard}
          Icon={MusicNote}
          canSelectViewType={false}
          showImages={true}
          canChangeSortBy={true}
          viewType="list"
          columns={[
            {
              id: 'nane',
              name: 'name',
              type: 'name',
              render: ({ node }) => {
                return (
                  <Link to={`../campaign/${node.id}`}>{node.name}</Link>
                )
              }
            }
          ]}
          heading={i18n.t('tracks')}
          baseUrl={`discovery-mode-campaign`}
        />
      
    </Container>
  )
}

export default DiscoveryModeCampaignsPage;